"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const formatDateTime_1 = __importDefault(require("./formatDateTime"));
const formatTime_1 = __importDefault(require("./formatTime"));
const formatDateRange = (from, to) => {
    const formattedFrom = formatDateTime_1.default(from);
    if (!to) {
        return formattedFrom;
    }
    const format = date_fns_1.isSameDay(from, to)
        ? formatTime_1.default
        : formatDateTime_1.default;
    return `${formattedFrom} - ${format(to)}`;
};
exports.default = formatDateRange;
